import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import NoIndex from "./NoIndex";
import useAuthApi from "../services/LandingPage/useAuthApi";
import { GlobalContext } from "../Context/GlobalContext";
import { ToastContainer } from "react-toastify";

const IdentityPage = () => {
  const navigate = useNavigate();

  const { ssoLogin, getUserAccess, fetchSubscriptionDetails, loading } =
    useAuthApi();

  const { setUser, setPower } = useContext(GlobalContext);

  const [verifying, setVerifying] = useState(true);

  //  UUID Generator
  const generateUUID = () =>
    ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16),
    );

  const verifyToken = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get("accessToken");

    if (!accessToken) {
      setVerifying(false);
      navigate("/");
      return;
    }

    try {
      //  STEP 1: SSO Login
      const loginResponse = await ssoLogin(accessToken);

      if (loginResponse?.responseCode !== "00") {
        navigate("/");
        return;
      }

      const userData = loginResponse.response;
      const userId = userData.userid;

      //  STEP 2: Store User
      sessionStorage.setItem("user", JSON.stringify(userData));
      setUser(userData);

      //  STEP 3: Generate Session
      const sessionID = generateUUID();
      sessionStorage.setItem("sessionID", sessionID);

      //  STEP 4: Subscription

      const subscriptionResponse = await fetchSubscriptionDetails(userId);

      const subscriptionData =
        subscriptionResponse?.data || subscriptionResponse?.response || {};

      const isActive =
        subscriptionResponse?.responseCode === "00" &&
        subscriptionData?.is_active === "1";

      if (isActive) {
        sessionStorage.setItem("power", "1");
        setPower("1");
      } else {
        sessionStorage.setItem("power", "0");
        setPower("0");

        navigate("/Profile/Plans");
        return;
      }

      //  STEP 5: Fetch Access (IMPORTANT)
      const accessResponse = await getUserAccess(userId);

      if (accessResponse?.responseCode === "00") {
        const entitlementData =
          accessResponse?.data ||
          accessResponse?.response?.data ||
          accessResponse?.response ||
          [];

        // sessionStorage.setItem("menuItems", JSON.stringify(entitlementData));
        // sessionStorage.getItem("entitlement");

        sessionStorage.setItem("entitlement", JSON.stringify(entitlementData));
      } else {
        console.warn("No access data received");
      }

      //  FINAL REDIRECT
      navigate("/dashboard");
    } catch (error) {
      console.error("Verification error:", error);
      navigate("/");
    } finally {
      setVerifying(false);
    }
  };

  useEffect(() => {
    verifyToken();
  }, []);

  return (
    <div className="h-screen w-full flex items-center justify-center montserrat-font-1">
      <NoIndex />
<ToastContainer/>

      {(loading || verifying) && (
        <div className="flex flex-col items-center gap-4 montserrat-font-1">
          <div className="h-14 w-14 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
          <p className="text-gray-600 text-sm font-medium montserrat-font-2">
            Verifying your account...
          </p>
        </div>
      )}
    </div>
  );
};

export default IdentityPage;
